import { render, staticRenderFns } from "./newChecklist.vue?vue&type=template&id=59c6aebc"
import script from "./newChecklist.vue?vue&type=script&lang=js"
export * from "./newChecklist.vue?vue&type=script&lang=js"
import style0 from "./newChecklist.vue?vue&type=style&index=0&id=59c6aebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports